module.exports = __webpack_public_path__ + "img/portfolio-post_on.e5e2427d.png";